export const MAX_PER_PAGE = 100

export interface Paginated<T> {
  rows: T[]
  hasMore: boolean
  nextCursor: string | null
  count: number | null
}

export interface CursorParams {
  cursor?: string
  perPage?: number
  withCount?: boolean
}

export function cursorParams(cursor?: string | null, perPage?: number): CursorParams {
  const params: CursorParams = {}
  if (cursor) params.cursor = cursor
  else params.withCount = true
  if (perPage) params.perPage = Math.min(perPage, MAX_PER_PAGE)
  return params
}

export const nextCursorOf = <T>(page?: Paginated<T> | null): string | undefined => (page?.hasMore ? (page.nextCursor ?? undefined) : undefined)

export function emptyPage<T>(): Paginated<T> {
  return { rows: [], hasMore: false, nextCursor: null, count: 0 }
}
